<template>
  <section
    v-editable="blok"
    :class="blok.isHScreen ? 'h-screen' : 'h-default'"
    class="our-work-list theme-light"
  >
    <div class="container">
      <div v-if="ourworks.length" class="our-work-list__body row">
        <div v-for="ourwork in ourworks" :key="ourwork.id" class="col-8">
          <component
            :is="'m-thumbnail' | dashify"
            :blok="getThumbnailConfig(ourwork)"
          />
        </div>
      </div>

      <div v-if="!ourworks.length" class="our-work-list__empty row">
        <div class="col-12">Sorry, there are no results.</div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'OurWork',
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
    datas: {
      type: Array,
      default: () => [],
    },
    requestData: {
      type: Boolean,
      default: true,
    },
    visible: {
      type: Boolean,
      default: () => false,
    },
    visibleSectionIndex: {
      type: Number,
      default: () => 1000,
    },
  },
  data() {
    return {
      ourworks: [],
    }
  },
  watch: {
    datas() {
      this.ourworks = this.datas
    },
    visible(visible) {
      if (visible) {
        this.$store.commit(
          'globals/setVisibleSectionName',
          this.blok.breadcrumb
        )
        this.$store.commit(
          'globals/setVisibleSectionIndex',
          this.visibleSectionIndex
        )
      }
    },
  },
  mounted() {
    if (this.requestData) {
      this.$storyapi
        .get('cdn/stories', {
          starts_with: this.blok.api ? this.blok.api : 'our-work/',
          is_startpage: '0',
          cv: this.$store.state.cacheVersion,
          filter_query: {
            tags: {
              in: 'Insights',
            },
          },
        })
        .then((res) => {
          this.ourworks = res.data.stories
        })
        .catch((res) => {
          // eslint-disable-next-line no-console
          console.error('Work List - Failed to load resource', res)
        })
    }
  },
  methods: {
    getThumbnailConfig(config) {
      return {
        variation: 'our-work',
        image: config.content.image,
        company: config.content.company,
        title: config.content.title,
        description: config.content.subtitle,
        tags: this.getTags(config.content.tags),
        link: this.sanitizeUrl(config.full_slug),
      }
    },
    getTags(tags) {
      let tagsText = ''

      for (let i = 0; i < tags.length; i += 1) {
        const separator = i ? ' / ' : ''
        tagsText += separator + tags[i].replace(/-/g, ' ')
      }

      return tagsText
    },
    sanitizeUrl(url) {
      return url && url.substr(0) !== '/' && url.substr(0, 3) !== 'http'
        ? `/${url}`
        : url
    },
  },
}
</script>

<style lang="scss">
@import '../../assets/scss/settings';

.our-work-list {
  padding-top: spacer(3);
  padding-bottom: spacer(3);

  .thumbnail {
    margin-bottom: 62px;
    img {
      width: 100%;
    }
  }
}

@include media-breakpoint-up(md) {
  .our-work-list {
    padding-top: spacer(6);

    .thumbnail {
      margin-bottom: 85px;
    }
  }

  .our-work-list__empty {
    padding-bottom: spacer(3);
  }
}
</style>
